import * as React from "react";
import * as ReactDOM from "react-dom";

import { DiagramContainer } from "./components/DiagramContainer";

import { getUrlVars } from "./helpers";


const protectiveFunctionId: number = parseInt(getUrlVars().get("protectiveFunctionId"));
const sessionTimeout = parseInt(document.getElementById("session-timeout").innerHTML);


ReactDOM.render(
  <DiagramContainer protectiveFunctionId={protectiveFunctionId} sessionTimeout={sessionTimeout}/>,
    document.getElementById("example")
);
